import ProdutoModel from "./ProdutoModel";
import C5ProdutoDAO from "../dataAccess/C5/C5ProdutoDAO";
import AppState from "./AppState";
import LojaModel from "./LojaModel";

export default class ConteudoModel {
  public conteudoId: string = "";
  public nome: string = "";
  public imagem: string = "";
  public tipo: string = "";
  public resumo: string = "";
  public conteudo?: string = "";
  public ingredientes?: string = "";
  public preparo?: string = "";
  public tempo_de_preparo?: string = "";
  public dificuldade?: string = "";
  public porcoes?: string = "";
  public produtoIDs?: string[] = [];
  public produtos?: ProdutoModel[] = [];
  public curtidoEm?: Date = new Date();

  public static async toModelProduto(items: any): Promise<ConteudoModel[]> {
    const conteudos: ConteudoModel[] = [];

    for (let conteudo of items.dicas) {
      conteudos.push({
        conteudoId: conteudo.id,
        nome: conteudo.title,
        imagem: conteudo.cover,
        tipo: "Dicas",
        resumo: conteudo.excerpt,
        conteudo: conteudo.content ? conteudo.content : "",
        ingredientes: conteudo.ingredientes ? conteudo.ingredientes : "",
        preparo: conteudo.preparo ? conteudo.preparo : "",
        tempo_de_preparo: conteudo.tempo_de_preparo
          ? conteudo.tempo_de_preparo
          : "",
        dificuldade: conteudo.dificuldade ? conteudo.dificuldade : "",
        porcoes: conteudo.porcoes ? conteudo.porcoes : "",
      } as ConteudoModel);
    }

    for (let conteudo of items.receitas) {
      conteudos.push({
        conteudoId: conteudo.id,
        nome: conteudo.title,
        imagem: conteudo.cover,
        tipo: "Receitas",
        resumo: conteudo.excerpt,
        conteudo: conteudo.content ? conteudo.content : "",
        ingredientes: conteudo.ingredientes ? conteudo.ingredientes : "",
        preparo: conteudo.preparo ? conteudo.preparo : "",
        tempo_de_preparo: conteudo.tempo_de_preparo
          ? conteudo.tempo_de_preparo
          : "",
        dificuldade: conteudo.dificuldade ? conteudo.dificuldade : "",
        porcoes: conteudo.porcoes ? conteudo.porcoes : "",
      } as ConteudoModel);
    }

    return conteudos;
  }

  public static async toModel(
    item: any,
    tipo: string,
    obterImagens: boolean
  ): Promise<ConteudoModel> {
    const produtos: ProdutoModel[] = [];
    const loja: LojaModel | null = AppState.getLojaSelecionada();
    const arrProms: any = [];

    if (loja) {
      if (obterImagens && item.produtos && Array.isArray(item.produtos)) {
        for (let produto of item.produtos) {
          arrProms.push(
            C5ProdutoDAO.getInstance()
              .getBuscaProdutos(produto.sku, "", loja.lojaId)
              .then((encontrados: ProdutoModel[]) => {
                for (let encontrado of encontrados) {
                  encontrado.quantidade = +produto.quantidade;
                  produtos.push(encontrado);
                }
              })
          );
        }
      }
    }

    await Promise.all(arrProms);

    return {
      conteudoId: item.id,
      nome: item.title,
      imagem: item.cover,
      tipo: tipo === "" ? item.tipo : tipo,
      resumo: item.excerpt,
      conteudo: item.content ? item.content : "",
      ingredientes: item.ingredientes ? item.ingredientes : "",
      preparo: item.preparo ? item.preparo : "",
      tempo_de_preparo: item.tempo_de_preparo ? item.tempo_de_preparo : "",
      dificuldade: item.dificuldade ? item.dificuldade : "",
      porcoes: item.porcoes ? item.porcoes : "",
      produtos,
    } as ConteudoModel;
  }
}
